<template>
  <q-input
    v-model="model"
    :placeholder="placeholder"
  >
    <template slot="append">
      <span>{{ commasValue }}</span>
      <span>{{ currency }}</span>
    </template>
  </q-input>
</template>
<script>
  import inputMixin from "./inputMixin";

  export default {
    name: 'QMoney',

    mixins: [inputMixin],

    props: {
      currency: {default: 'ریال'},
    },
    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },

      commasValue() {
        if (this.model === null || this.model === undefined)
          return 0;
        else
          return (this.model / 1).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
  };
</script>
